import React from "react";
import { Card, Table } from "react-bootstrap";
import { FaTable } from "react-icons/fa";
import { CartographySupplier } from "./types";
import { displayValue, getBadgeClass } from "./cartographyUtils";
import {
  AIDA_BADGE_OPTIONS,
  AIDA_CATEGORY_OPTIONS,
  getAidaOptionLabel,
} from "../../constants/aidaClassification";

interface Props {
  suppliers: CartographySupplier[];
}

const SuppliersCartographyTable: React.FC<Props> = ({ suppliers }) => {
  return (
    <Card className="aida-panel-card">
      <Card.Body>
        <div className="aida-section-heading mb-3">
          <div>
            <h5><FaTable /> Tableau national des sous-traitants</h5>
            <p>Détail institutionnel : localisation, filière, capacité, homologation, export et substitution import.</p>
          </div>
        </div>

        <div className="table-responsive aida-table-scroll-lg">
          <Table hover className="aida-table align-middle mb-0">
            <thead>
              <tr>
                <th>Fournisseur</th>
                <th>Wilaya</th>
                <th>Filière</th>
                <th>Categorie AIDA</th>
                <th>Badge</th>
                <th>Produits</th>
                <th>Capacité</th>
                <th>Besoin</th>
                <th>Couverture</th>
                <th>Niveau</th>
                <th>Homologation</th>
                <th>Export</th>
                <th>Substitution</th>
                <th>Alertes</th>
              </tr>
            </thead>
            <tbody>
              {suppliers.map((supplier) => (
                <tr key={supplier.id_supplier}>
                  <td>
                    <strong>{supplier.legal_name}</strong>
                    <div className="text-muted small">{supplier.trade_name || supplier.email || ""}</div>
                  </td>
                  <td>{displayValue(supplier.wilaya)}</td>
                  <td>{displayValue(supplier.mainSector)}</td>
                  <td>
                    {getAidaOptionLabel(
                      AIDA_CATEGORY_OPTIONS,
                      supplier.aida_category,
                    )}
                  </td>
                  <td>
                    <span className={getBadgeClass(supplier.aida_badge)}>
                      {getAidaOptionLabel(AIDA_BADGE_OPTIONS, supplier.aida_badge)}
                    </span>
                  </td>
                  <td>{supplier.products.length}</td>
                  <td>{supplier.totalCapacity}</td>
                  <td>{supplier.requestedCapacity || "Non renseigné"}</td>
                  <td>
                    <span className={getBadgeClass(supplier.coverageRate !== null ? "Capacitaire" : "Non renseigné")}>
                      {supplier.coverageRate !== null ? `${supplier.coverageRate}%` : "Non renseigné"}
                    </span>
                  </td>
                  <td><span className={getBadgeClass(supplier.pyramid_level)}>{displayValue(supplier.pyramid_level)}</span></td>
                  <td><span className={getBadgeClass(supplier.homologation_status)}>{displayValue(supplier.homologation_status)}</span></td>
                  <td><span className={getBadgeClass(supplier.export_potential)}>{displayValue(supplier.export_potential)}</span></td>
                  <td>{supplier.substitutionProducts}</td>
                  <td><span className={supplier.nonCapacitaryProducts > 0 ? "aida-badge-danger" : "aida-badge-muted"}>{supplier.nonCapacitaryProducts}</span></td>
                </tr>
              ))}
              {suppliers.length === 0 && (
                <tr>
                  <td colSpan={14} className="text-center text-muted py-4">Aucun fournisseur trouvé pour les filtres sélectionnés.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SuppliersCartographyTable;
